import request from '@/utils/request'

//5.1新闻分类
export function by_typename(langueType, params) {
    return request({
        url: `/${langueType}/wms/dqgx/by_typename`,
        method: 'get',
        params
    })
}
//4首页新闻
export function gettopnewlist(langueType) {
    return request({
        url: `/${langueType}/wms/dqgx/gettopnewlist`,
        method: 'get',
    })
}
//5.1新闻列表
export function getnewlist(langueType, data, pageReq) {
    return request({
        url: `/${langueType}/wms/dqgx/getnewlist`,
        method: 'post',
        data,
        params: pageReq
    })
}
//新闻详情
export function getnewdetail(langueType, id) {
    return request({
        url: `/${langueType}/wms/dqgx/getnewdetail/${id}`,
        method: 'get',
    })
}

//5.1新闻列表-根据分类获取
export function gettopnewlistByType(langueType, params) {
    return request({
        url: `/${langueType}/wms/dqgx/gettopnewlistByType`,
        method: 'get',
        params
    })
}